import FAQSectionI18n from "@/components/landing/shared/FAQSectionI18n";
const FAQAnalyticsSection = () => <FAQSectionI18n translationPrefix="analyticsPage" />;
export default FAQAnalyticsSection;
